<!-- Start::slideshow si tiene mas de un item (lg+) -->
<div *ngIf="slides.length > 1" class="block-slideshow hidden lg:block">
  <owl-carousel-o
    class="carouselMundo"
    [options]="carouselOptions"
    appOwlPreventClick
  >
    <ng-container *ngFor="let slide of slides; let i = index">
      <ng-template
        carouselSlide
        [id]="slide.image_classic"
        style="height: 300px !important"
      >
        <div>
          <a [href]="slide.url" rel="nofollow" (click)="onClickCapsule(i)">
            <ng-container>
              <img
                [src]="slide.imageTablet"
                [alt]="slide.alt"
                [title]="slide.alt"
                class="img-fluid-product"
              />
            </ng-container>
            <div class="overlay">
              <div class="text flex flex-column justify-content-center">
                <h3 style="text-align: center" *ngIf="slide.title !== '.'">
                  {{ slide.title }}
                </h3>
                <h6 class="fw-normal text-center" *ngIf="slide.description">
                  {{ slide.description }}
                </h6>
              </div>
              <div class="mundo" [ngStyle]="style[i]"></div>
              <div class="poligono" [ngStyle]="slide.styleColor"></div>
            </div>
          </a>
        </div>
      </ng-template>
    </ng-container>
  </owl-carousel-o>
</div>
<!-- End::slideshow si tiene mas de un item (lg+) -->

<!-- Start::slideshow si tiene un solo item (lg+) -->
<div *ngIf="slides.length == 1" class="block-slideshow hidden lg:block">
  <owl-carousel-o
    class="carouselMundo"
    [options]="carouselOptions2"
    appOwlPreventClick
  >
    <ng-container *ngFor="let slide of slides; let i = index">
      <ng-template
        carouselSlide
        [id]="slide.image_classic"
        style="height: 300px !important"
      >
        <div>
          <a [href]="slide.url" (click)="onClickCapsule(i)">
            <ng-container>
              <img
                [src]="slide.imageTablet"
                [alt]="slide.alt"
                [title]="slide.alt"
                class=".img-fluid-product lazyload"
              />
            </ng-container>
            <div class="overlay">
              <div class="text flex flex-column justify-content-center">
                <h3 style="text-align: center" *ngIf="slide.title !== '.'">
                  {{ slide.title }}
                </h3>
                <h6
                  class="fw-normal text-center"
                  *ngIf="!isVacio(slide.description)"
                >
                  {{ slide.description }}
                </h6>
              </div>
              <div class="mundo_0" [ngStyle]="style[i]"></div>
              <div class=".poligono_0" [ngStyle]="slide.styleColor"></div>
            </div>
          </a>
        </div>
      </ng-template>
    </ng-container>
  </owl-carousel-o>
</div>
<!-- End::slideshow si tiene un solo item (lg+) -->

<!-- Start:slideshow xs, sm y md -->
<div class="block-slideshow block lg:hidden">
  @if(slides && slides.length > 0) {
  <owl-carousel-o
    class="carouselMundo"
    [options]="carouselOptions2"
    appOwlPreventClick
  >
    <ng-container *ngFor="let slide of slides; let i = index">
      <ng-template
        carouselSlide
        [id]="slide.image_classic"
        style="height: 300px !important"
      >
        <div>
          <a [href]="slide.url" (click)="onClickCapsule(i)">
            <img
              [src]="slide.imageMobile"
              [alt]="slide.alt"
              [title]="slide.alt"
              class="img-fluid-product hidden sm:block"
            />

            <img
              [src]="slide.imageTablet"
              [alt]="slide.alt"
              [title]="slide.alt"
              class="img-fluid-product block sm:hidden"
            />

            <div class="overlay">
              <div class="text flex flex-column justify-content-center">
                <h3 style="text-align: center" *ngIf="slide.title !== '.'">
                  {{ slide.title }}
                </h3>
                <h6
                  class="fw-normal text-center"
                  *ngIf="!isVacio(slide.description)"
                >
                  {{ slide.description }}
                </h6>
              </div>
              <div class="mundo" [ngStyle]="style[i]"></div>
              <div class="poligono" [ngStyle]="slide.styleColor"></div>
            </div>
          </a>
        </div>
      </ng-template>
    </ng-container>
  </owl-carousel-o>
  }
</div>
